var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAguaOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6659 0C37.4541 7.33884 43.0786 13.0909 48.3153 19.2397C57.4309 29.7521 56.849 43.6364 47.5395 53.157C38.4238 62.281 23.4897 62.281 14.1802 53.157C4.87058 43.8347 4.28873 29.7521 13.2104 19.2397C18.2531 13.0909 24.0716 7.33884 30.6659 0Z",
    fill: "#FF972F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAguaOrange);
export default __webpack_public_path__ + "static/media/agua-orange.7151b2b892b816dbb38577e924477282.svg";
export { ForwardRef as ReactComponent };